module.exports = __webpack_public_path__ + "static/media/GreeceBlocks_5_1_drop_3.3a2662d9.png";